import React from 'react';
import { SurveyMainType } from '../../types/SurveyMainType';
import { SurveyQuestionType } from '../../types/SurveyQuestionType';
import { GenerateQuestion } from './GenerateQuestion';

interface ISurveyStringProps {
    question: SurveyQuestionType;
    pppData?: React.Dispatch<React.SetStateAction<SurveyMainType | undefined>>;
    errorIds?: number[];
}

const SurveyString = ({
    question,
    pppData,
    errorIds
}: ISurveyStringProps) => {
    return (
        <>
            <p style={{ fontSize: '11px' }}>
                <div dangerouslySetInnerHTML={{ __html: question.text }} />
            </p>

            {question.subQuestions ? (
                question.subQuestions.map((subQuestion) => {
                    return <GenerateQuestion question={subQuestion} pppData={pppData} />
                })


            ) : null}
        </>
    );
};

export {
    SurveyString
}